import { useEffect, useState } from 'react';
import useCount from '../../../hooks/useCount';
import { TextField } from '@mui/material';
import { RadioGroup, FormControlLabel, Radio } from '@mui/material';

import PropTypes from 'prop-types';

import translating from '../translate.json';

function percentage(partialValue, totalValue) {
  return (totalValue * partialValue) / 100;
}

const Product = ({ product, discount, isInCart, handleAction }) => {
  const { renderCounter, count } = useCount();
  const [sumDiscount, setSumDiscount] = useState(0);
  const [typeDiscount, setTypeDiscount] = useState('1');
  const [isChanged, setIsChanged] = useState(false);
  const [discountError, setDiscountError] = useState(false);

  useEffect(() => {
    if (isInCart) {
      setIsChanged(true);
    }
  }, [count, sumDiscount, typeDiscount]);

  const validateDiscount = (value) => {
    if (
      (typeDiscount === '1' && value > product.maxPercentDiscountAmount) ||
      (typeDiscount === '2' && value > product.maxFixedDiscountAmount * count)
    ) {
      setDiscountError(true);
      return false;
    }
    return true;
  };

  let total =
    typeDiscount === '1' && product.price > 0
      ? (
          (product.price - percentage(sumDiscount, product.price)) *
          count
        ).toFixed(2)
      : (product.price * count - sumDiscount * count).toFixed(2);
  return (
    <div className={`product ${isInCart ? 'active' : ''}`}>
      <div className="product-header">
        <div className="product-name">{product.name}</div>
        <div className="product-price">{`${product.price} ${translating.shekel}`}</div>
      </div>

      <div className="product-buy">
        <div className="product-count">
          <div className="count-label">{translating.count}</div>
          {renderCounter()}
        </div>
        <div className="wrapper-discount">
          <div className="sum-discaount-area">
            <div className="count-label">{translating.discount}</div>
            <TextField
              onMouseEnter={() => setDiscountError(false)}
              onChange={(e) => {
                if (validateDiscount(e.target.value)) {
                  if (e.target.value >= 0) setSumDiscount(e.target.value);
                } else setSumDiscount(0);
              }}
              type="number"
              // value={`${sumDiscount}${typeDiscount === '1'? '%':'שח'}`}
              value={`${sumDiscount}`}
              inputProps={{
                style: {
                  padding: 0,
                  width: '39px',
                  height: '40px',
                  textAlign: 'center',
                  borderColor: 'transpert'
                }
              }}
            ></TextField>
          </div>
          <div className="wrapper-discount-type">
            <RadioGroup
              classes={{ root: 'radioFormRoot' }}
              defaultValue={'1'}
              onChange={(e) => {
                setTypeDiscount(e.target.value);
                setSumDiscount(0);
              }}
            >
              {discount?.map((option, index) => (
                <FormControlLabel
                  key={index}
                  value={option.id}
                  control={<Radio classes={{ root: 'radioRoot' }} />}
                  label={option.name}
                />
              ))}
            </RadioGroup>
          </div>
        </div>
      </div>
      {discountError && <div className="discount-err">הנחה מוגבלת</div>}
      <div className="product-sum-all">
        <div className="count-label">{translating.sumTopay}</div>
        <div className="sum-all">{`${total} ${translating.shach}`}</div>
      </div>

      <div
        onClick={() => {
          handleAction(
            product,
            count,
            typeDiscount,
            sumDiscount,
            total,
            isChanged
          );
          setIsChanged(false);
        }}
        className="product-bottom"
      >{`${
        isInCart
          ? isChanged
            ? translating.updateCart
            : translating.remove
          : translating.addToCart
      }`}</div>
    </div>
  );
};

export default Product;

Product.propTypes = {
  product: PropTypes.object,
  isInCart: PropTypes.object,
  handleAction: PropTypes.func,
  discount: PropTypes.array
};
